import React, { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import UISpinner from 'Components/UIComponents/UISpinner';
import useDocumentActivitiesDownload from 'Hooks/Document/useDocumentActivitiesDownload';
import { Document, DocumentDownloadPayload } from 'Interfaces/Document';
import { UnauthorizedRoutePaths } from 'Interfaces/RoutePaths';
import Toast from 'Services/Toast';

type PageParams = {
  documentId: Document['id'];
};

export const DocumentActivitiesDownload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams<PageParams>();

  const [
    downloadDocumentActivities,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDownloading,
    isReady,
  ] = useDocumentActivitiesDownload();

  const handleDocumentActivitiesDownload = useCallback(
    async (payload: DocumentDownloadPayload) => {
      try {
        await downloadDocumentActivities(payload);
      } catch (err) {
        Toast.handleErrors(err, { toastId: 'activities_download_error' });
      } finally {
        navigate(UnauthorizedRoutePaths.BASE_PATH, { replace: true });
      }
    },
    [downloadDocumentActivities, navigate],
  );

  const { hash, documentId } = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const { documentId } = params || {};

    return {
      hash: searchParams.get('hash'),
      documentId,
    };
  }, [location.search, params]);

  useEffect(() => {
    if (hash && documentId && isReady) {
      handleDocumentActivitiesDownload({
        hash,
        documentId,
      });
    }
  }, [hash, documentId, isReady, handleDocumentActivitiesDownload]);

  return <UISpinner width={50} height={50} wrapperClassName="spinner--main__wrapper" />;
};
